import { render } from "./Search.vue?vue&type=template&id=3187ad0c&scoped=true&ts=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=3187ad0c&scoped=true&lang=scss"

import exportComponent from "/Users/icer/Works/2105-chia/_cns/ChiaNameServiceSite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3187ad0c"]])

export default __exports__